import React, { useEffect } from 'react'

import { theme } from '@acorns/grove'
import { useRemoteStrings } from '@acorns/web-utils'

import { trackRegistrationReopenNextStepsScreenViewedPayload } from 'generated/trackingEvents'
import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'

import type { GetStep } from './ClosedAccount'
import {
  MessageContainer,
  NEXT_STEPS_SLIDE_DURATION_MS,
  NextStepsSlideContent,
} from './styled-components'

export const NextSteps = ({
  setStep,
  getStep,
}: {
  setStep: (index: number) => void
  getStep: GetStep
}) => {
  const { StyledRemoteString } = useRemoteStrings()

  const containerRef = useAnalyticsComponentViewed({
    generatedPayload: trackRegistrationReopenNextStepsScreenViewedPayload({
      funnel: 'Reopen',
    }),
  })

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setStep(getStep('Confirmation'))
    }, NEXT_STEPS_SLIDE_DURATION_MS)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [setStep, getStep])

  return (
    <MessageContainer ref={containerRef}>
      <NextStepsSlideContent>
        <StyledRemoteString
          stringKey="registration.ssn_collision.next_steps.title.markdown"
          modifiers={[{ color: theme.colors.primaryGreen, bold: 600 }]}
        />
      </NextStepsSlideContent>
    </MessageContainer>
  )
}
